export default __webpack_public_path__ + "static/media/spotify-service.1d6d9b89.svg";